// extracted by mini-css-extract-plugin
export var lg = "_dv-7";
export var md = "_dv-6";
export var placeholderContainer = "_dv-1";
export var placeholderIcon = "_dv-2";
export var productImage = "_dv-0";
export var sm = "_dv-5";
export var xl = "_dv-8";
export var xs = "_dv-4";
export var xxs = "_dv-3";